type CarPriceFieldProps = {
    fieldKey: string;
    size?: number;
};

const CarPriceField = ({ fieldKey, size }: CarPriceFieldProps) =>
    // return null to hide up the component
    null;
export default CarPriceField;
